var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbClickToSendEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-click-to-send-email-icon_svg__clip0_7436_29546)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm18 0H4v12h16V6zM5.168 7.445a1 1 0 011.387-.277L12 10.798l5.445-3.63a1 1 0 011.11 1.664l-6 4a1 1 0 01-1.11 0l-6-4a1 1 0 01-.277-1.387z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-click-to-send-email-icon_svg__clip0_7436_29546"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgIbClickToSendEmailIcon;